import { ArrowBackRoundedIcon } from "@l2r-front/l2r-icons"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { BottomSheetHeights, useApplicationStateContext } from "@l2r-front/l2r-utils"

import { useIsMobileDevice } from "../../hooks/useIsMobileDevice"

import * as Styled from "./BottomSheetContent.styled"

export function BottomSheetContent(props) {

    const {
        id,
        title,
        titleBottomComponent,
        titleSideComponent,
        onBack,
        children,
        className,
    } = props

    const isMobile = useIsMobileDevice()
    const { currentBottomSheetHeight } = useApplicationStateContext()

    return (
        <Styled.Container>
            <Styled.ContentHeader isMobile={isMobile} hasBottomComponent={!!titleBottomComponent}>
                <Styled.TitleContainer>
                    {onBack &&
                        <Styled.Button id={`${id}-return-button`} color="objects/object-black" onClick={onBack}>
                            <ArrowBackRoundedIcon color="objects/object-black" />
                        </Styled.Button>
                    }
                    <Styled.Title id={`${id}-title`} variant="H1">{title}</Styled.Title>
                    {titleSideComponent &&
                        <Styled.TitleSideComponent>{titleSideComponent}</Styled.TitleSideComponent>
                    }
                </Styled.TitleContainer>

                {titleBottomComponent}
            </Styled.ContentHeader>
            <Styled.ContentScrollContainer id="scroll" allowScroll={!isMobile || currentBottomSheetHeight >= BottomSheetHeights.HALF}>
                <Styled.ContentContainer id="content" className={className}>
                    {children}
                </Styled.ContentContainer>
            </Styled.ContentScrollContainer>
        </Styled.Container>
    )
}

BottomSheetContent.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    titleBottomComponent: PropTypes.element,
    tileSideComponent: PropTypes.element,
    onBack: PropTypes.func,
    children: PropTypes.node,
}